<script>
import { Bar } from 'vue-chartjs'

function formatCurrency (value) {
  return (new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })).format(value)
}

function formatNumber (value) {
  return (new Intl.NumberFormat('en-US')).format(value)
}

export default {
  extends: Bar,
  props: {
    costAnalysis: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [
        {
          type: 'line',
          label: 'Weight',
          yAxisID: 'y-axis-0',
          data: [],
          borderColor: '#ffd166',
          borderWidth: 2,
          fill: false
        },
        {
          type: 'bar',
          label: 'Cost',
          yAxisID: 'y-axis-1',
          data: [],
          backgroundColor: '#118ab2',
          borderColor: 'white',
          borderWidth: 0
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        intersect: false,
        mode: 'index',
        callbacks: {
          label: function (tooltipItems, data) {
            let labelLeft = data.datasets[tooltipItems.datasetIndex].label + ': '
            let labelRight = tooltipItems.yLabel

            if (tooltipItems.datasetIndex === 0) {
              labelRight = formatNumber(labelRight) + 'kg'
            } else if (tooltipItems.datasetIndex === 1) {
              labelRight = formatCurrency(labelRight)
            }

            return labelLeft + labelRight
          }
        }
      },
      scales: {
        xAxes: [
          {
            ticks: {
              minRotation: 45
            }
          }
        ],
        yAxes: [
          {
            id: 'y-axis-0',
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                return formatNumber(value) + 'kg'
              }
            }
          },
          {
            id: 'y-axis-1',
            type: 'linear',
            position: 'right',
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                return formatCurrency(value).slice(0, -3)
              }
            },
            gridLines: {
              display: false
            }
          }
        ]
      },
      legend: {
        display: true,
        reverse: false,
        labels: {
          usePointStyle: true
        },
        onClick: null
      },
      layout: {
        padding: {
          left: 20,
          right: 30,
          top: 10,
          bottom: 10
        }
      }
    }
  }),
  mounted () {
    this.chartdata.labels = this.$props.costAnalysis.map(d => d.label)
    this.chartdata.datasets[0].data = this.$props.costAnalysis.map(d => d.weight)
    this.chartdata.datasets[1].data = this.$props.costAnalysis.map(d => d.cost)

    // Sorts the dataset by cost
    this.addPlugin({
      datasets: [],
      getData: function (labels, datasets) {
        const sum = []

        for (var i = 0; i < datasets[0].length; i++) {
          sum.push({
            label: labels[i],
            data: datasets.map(e => e[i]),
            get sum () {
              return this.data.reduce((a, b) => a + b)
            }
          })
        }

        return sum
      },
      beforeInit: function (chart) {
        chart.data.datasets.forEach((dataset, datasetIndex) => {
          this.datasets.push(dataset.data)
        })

        const dataStore = this.getData(chart.data.labels, this.datasets).sort((a, b) => {
          if (a.data.length === 2 && b.data.length === 2) {
            // If the dataset has 2 elements, assume we have Charge Weight, Cost
            return b.data[1] - a.data[1]
          } else {
            // Else fall back to the sum of the dataset
            return b.sum - a.sum
          }
        })

        dataStore.forEach((d, i) => {
          chart.data.labels[i] = d.label
          d.data.forEach((v, vi) => {
            chart.data.datasets[vi].data[i] = v
          })
        })
      }
    })

    // Add extra padding to the legend
    this.addPlugin({
      beforeInit: function (chart) {
        chart.legend.afterFit = function () {
          this.height = this.height + 20
        }
      }
    })

    this.renderChart(this.chartdata, this.options)
  }
}
</script>
